module.exports = __webpack_public_path__ + "static/images/item-tag.9a737db2b5117e03631741d208e37206.svg";